import React, { useState, createContext } from "react";

const FormContext = createContext();
function FormProvider(props) {
  const [forms, setForms] = useState([]);
  return (
    <FormContext.Provider value={[forms, setForms]}>
      {props.children}
    </FormContext.Provider>
  );
}

const ReviewMatrixContext = createContext();
function ReviewMatrixProvider(props) {
  const [calculatedValues, setCalculatedValues] = useState([]);
  const [isCalculated, setIsCalculated] = useState(false);
  return (
    <ReviewMatrixContext.Provider
      value={[
        calculatedValues,
        setCalculatedValues,
        isCalculated,
        setIsCalculated,
      ]}
    >
      {props.children}
    </ReviewMatrixContext.Provider>
  );
}

const LoanOfficerContext = createContext();
function LoanOfficerProvider(props) {
  const [newEntries, setNewEntries] = useState([]);
  return (
    <LoanOfficerContext.Provider value={[newEntries, setNewEntries]}>
      {props.children}
    </LoanOfficerContext.Provider>
  );
}

const OriginatorListContext = createContext();
function OriginatorListProvider(props) {
  const  [originatorNames, setOriginatorNames] = useState([]);
  return (
    <OriginatorListContext.Provider value={[originatorNames, setOriginatorNames]}>
      {props.children}
    </OriginatorListContext.Provider>
  );
}


const ApplicationStatusContext = createContext();
function ApplicationStatusProvider(props) {
  const [cxSpecialist, setCxSpecialist] = useState();
  const [cxSpecialists, setCxSpecialists] = useState([]);
  const [newApplicationStatus, setNewApplicationStatus] = useState(1);
  return (
    <ApplicationStatusContext.Provider
      value={[
        cxSpecialist,
        setCxSpecialist,
        newApplicationStatus,
        setNewApplicationStatus,
        cxSpecialists,
        setCxSpecialists
      ]}
    >
      {props.children}
    </ApplicationStatusContext.Provider>
  );
}

const TestApplicationContext = createContext();
function TestApplicationProvider(props) {
  const [isTest, setIsTest] = useState(null);
  return (
    <TestApplicationContext.Provider value={[isTest, setIsTest]}>
      {props.children}
    </TestApplicationContext.Provider>
  );
}

const UserRoleContext = createContext();
function UserRoleProvider(props) {
  const [role, setRole] = useState(null);
  return (
    <UserRoleContext.Provider value={[role, setRole]}>
      {props.children}
    </UserRoleContext.Provider>
  );
}

const PropertyDisclosureIssueContext = createContext();
function PropertyDisclosureIssueProvider(props) {
  const [spaceSpecificationsList,setSpaceSpecificationsList]=useState([]);
  return (
    <PropertyDisclosureIssueContext.Provider value={[spaceSpecificationsList,setSpaceSpecificationsList]}>
      {props.children}
    </PropertyDisclosureIssueContext.Provider>
  );
}

export {
  FormContext,
  FormProvider,
  ReviewMatrixContext,
  ReviewMatrixProvider,
  LoanOfficerContext,
  LoanOfficerProvider,
  ApplicationStatusContext,
  ApplicationStatusProvider,
  TestApplicationContext,
  TestApplicationProvider,
  UserRoleContext,
  UserRoleProvider,
  OriginatorListContext,
  OriginatorListProvider,
  PropertyDisclosureIssueContext,
  PropertyDisclosureIssueProvider
};
